import * as thankYouActions from "./thank-you.actions";
import { Action, createReducer, on } from "@ngrx/store";
import { ThanksYouState } from "./thank-you.state";

const initialState: ThanksYouState = null;

const featureReducer = createReducer(
	initialState,
	on(thankYouActions.setThankYou, (state, { thankYou }) => {
		return {
			...state,
			salesId: thankYou?.salesId?.toString()
		};
	})
);

export function thankYouReducer(state: ThanksYouState | undefined, action: Action): ThanksYouState | undefined {
	return featureReducer(state, action);
}
